import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import EditVoid from './EditVoid';
import FormInputText from '../../_shared/forms/FormInputText';
import FormCheckbox from '../../_shared/forms/FormCheckbox';
import DatePicker from 'react-datepicker';
import FormError from '../../_shared/forms/FormError';
import { snakeCaseToTitle } from '../../../utils/Helpers';
import moment from 'moment';
import JobExtras from '../JobExtras';
import FormMultiSelect, { SearchableSelect } from '../../_shared/forms/FormMultiSelect';
import DtnPhotos from './paritals/DtnPhotos';
import SubmitButton from '../../_shared/SubmitButton';
import DtnService from '../../../services/DtnService';
import DriverSignature from './paritals/DriverSignature';
import PricingDetails from './paritals/PricingDetails';
import StatusButtons from './paritals/StatusButtons';
import FormInputNumber from '../../_shared/forms/FormInputNumber';
import CustomerDetails from './paritals/CustomerDetails';
import OperativeDetails from './paritals/OperativeDetails';

class EditTyreCollection extends Component {
    constructor(props) {
        super(props);

        let { job, dtn, type } = this.props;

        let collection_date = dtn.collection_date ? new Date(dtn.collection_date) : '';
        let completion_time = dtn.completion_time ? new Date(dtn.completion_time) : '';
        let time_before_loading = type.time_before_loading ? new Date(type.time_before_loading) : '';
        let time_after_loading = type.time_after_loading ? new Date(type.time_after_loading) : '';
        let job_notes = dtn.job_notes !== 'no' ? dtn.job_notes : '';

        let tipOffOptions = [...this.props.tipOffOptions];
        let tipOff = tipOffOptions.find((tipOff) => {
            return tipOff.value === this.props.job.tip_off_id;
        });

        this.state = {
            address: job.address_line_1 || '',
            postcode: job.postcode || '',
            collection_date: collection_date,
            completion_time: completion_time,
            job_notes: job_notes || '',
            time_before_loading: time_before_loading,
            time_after_loading: time_after_loading,
            waste_contained: type.waste_contained || 'Loose',
            waste_description: type.waste_description || 'General Mixed Waste 20 03 01',
            extras_options: this.props.tyreTypes,
            selected_extras: job.job_extras || [],
            jobTypePrice: 0,
            totalPrice: 0,
            providerJobTypePrice: 0,
            providerTotalPrice: 0,
            loading: false,
            images_before: '',
            images_after: '',
            van_images_before: '',
            van_images_after: '',
            customer_signature: '',
            rejected_files: {},
            errors: {},
            tipOff: typeof tipOff !== 'undefined' ? tipOff : [],
            quantity: job.quantity || 0,
            provider_quantity: job.provider_quantity || 0,
            admin_notes: this.props.job.admin_notes || 0,
            purchase_order_number: job.purchase_order_number || '',
            sla: job.sla || '',
            price_quoted: job.price_quoted === 1 ? 'yes' : 'no',
            custom_price: job.custom_price || 0,
            custom_price_with_vat: job.custom_price ? job.custom_price * 1.2 : 0,
            disable_status_buttons: false,
            provider_price_quoted: job.provider_price_quoted === 1 ? 'yes' : 'no',
            provider_custom_price: job.provider_custom_price || '',
            provider_custom_price_with_vat: job.provider_custom_price ? job.provider_custom_price * 1.2 : '',
            route_started: '',
            route_arrived: '',
            first_operative: {},
            second_operative: {},
            job_completed: '',
            manager_review: job.manager_review === 1 ? 'yes' : 'no',
            manager_review_reason: job.manager_review_reason || '',
        };
        this.dtnService = new DtnService();
    }

    componentDidMount() {
        let jobTypePrice = this.setJobTypePrice();
        let providerJobTypePrice = this.setProviderJobTypePrice();
        this.calculateTotalPrice(jobTypePrice, providerJobTypePrice);

        // if(!this.props.job.waste_tipping_id && this.props.job.status !== 'completed') {
        //     this.jobNotTippedModal();
        // }
    }

    jobNotTippedModal = () => {
        window.swal.fire({
            title: `Waste not tipped`,
            text: ``,
            type: 'info',
            confirmButtonText: `Ok`,
        });
    };

    setJobTypePrice = () => {
        let jobType = this.props.jobTypes.find((jobType) => {
            return jobType.id === this.props.job.job_type_id;
        });

        let jobTypePrice = jobType.pivot.price;

        this.setState({
            jobTypePrice: jobTypePrice,
        });

        return jobTypePrice;
    };

    setProviderJobTypePrice = () => {
        let providerJobType = this.props.serviceProvider.job_types.find((jobType) => {
            return jobType.id === this.props.job.job_type_id;
        });
        let providerJobTypePrice;

        if (typeof providerJobType !== 'undefined') {
            providerJobTypePrice = providerJobType.pivot ? providerJobType.pivot.price : providerJobType.default_price;
        } else {
            providerJobType = this.props.jobTypes.find((jobType) => {
                return jobType.id === this.props.job.job_type_id;
            });
            providerJobTypePrice = providerJobType.provider_default_price || 0;
        }

        this.setState({
            providerJobTypePrice: providerJobTypePrice,
        });

        return providerJobTypePrice;
    };

    calculateTotalPrice = (jobTypePrice, providerJobTypePrice) => {
        let totalPrice = jobTypePrice * this.state.quantity;
        let providerTotalPrice = providerJobTypePrice * this.state.provider_quantity;

        if (this.state.selected_extras) {
            this.state.selected_extras.map((extra) => {
                if (extra.name.toLowerCase() === 'agricultural truck' || extra.name.toLowerCase() === 'fork truck') {
                    totalPrice += extra.price * extra.total_weight;
                    providerTotalPrice += extra.providerPrice * extra.provider_total_weight;
                } else {
                    totalPrice += extra.price * (extra.quantity ? extra.quantity : 1);
                    providerTotalPrice += extra.providerPrice * (extra.provider_quantity ? extra.provider_quantity : 1);
                }
            });
        }

        this.setState({
            totalPrice: totalPrice,
            providerTotalPrice: providerTotalPrice,
        });
    };

    handleDateChange = (date, name) => {
        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];
        this.setState({ [name]: date, errors: errorsObject });
    };

    handleChange = (e) => {
        let { name, value, type } = e.target;

        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];

        if (type === 'checkbox') value = this.state[name] === 'yes' ? 'no' : 'yes';

        this.setState(
            {
                [name]: value,
                errors: errorsObject,
            },
            () => {
                if (name === 'provider_quantity' || name === 'quantity') {
                    this.calculateTotalPrice(this.state.jobTypePrice, this.state.providerJobTypePrice);
                }
            }
        );
    };

    handleMultiSelectChange = (value, type) => {
        let extras = [];

        if (value !== null && typeof value !== 'undefined' && value.length > 0) {
            extras = [...value];

            if (!extras[extras.length - 1].hasOwnProperty('quantity')) {
                extras[extras.length - 1].quantity = 1;
            }

            if (
                !extras[extras.length - 1].hasOwnProperty('provider_quantity') ||
                extras[extras.length - 1].provider_quantity === ''
            ) {
                extras[extras.length - 1].provider_quantity = 1;
            }
        }
        this.setState(
            {
                [type]: extras,
            },
            () => {
                this.calculateTotalPrice(this.state.jobTypePrice, this.state.providerJobTypePrice);
            }
        );
    };

    handleExtraQtyChange = (e, extra, type, field) => {
        let extras = [...this.state[type]];

        let extraIndex = extras.findIndex((ex) => ex.value === extra.value);

        extras[extraIndex][field] = e.target.value;

        if (e.target.name === 'quantity') {
            extras[extraIndex]['provider_quantity'] = e.target.value;
        }

        this.setState(
            {
                [type]: extras,
            },
            () => {
                this.calculateTotalPrice(this.state.jobTypePrice, this.state.providerJobTypePrice);
            }
        );
    };

    handleExtraTotalWeightChange = (e, extra) => {
        let extras = [...this.state.selected_extras];

        let extraIndex = extras.findIndex((ex) => ex.value === extra.value);
        extras[extraIndex].total_weight = e.target.value;
        if (e.target.name === 'total_weight') {
            extras[extraIndex]['provider_total_weight'] = e.target.value;
        }
        this.setState({
            selected_extras: extras,
        });
    };
    handleCustomPriceChange = (e) => {
        let { name, value } = e.target;

        const numericValue = Number(value); // key fix

        let custom_price, custom_price_with_vat;

        if (name === 'custom_price') {
            custom_price = numericValue;
            custom_price_with_vat = +(numericValue * 1.2).toFixed(2);
        } else {
            custom_price_with_vat = numericValue;
            custom_price = +(numericValue / 1.2).toFixed(2);
        }

        this.setState({
            custom_price,
            custom_price_with_vat,
        });
    };

    handleProviderCustomPriceChange = (e) => {
        const { name, value } = e.target;
        const numericValue = parseFloat(value) || 0;
        if (name === 'provider_custom_price') {
            this.setState({
                provider_custom_price: numericValue,
                provider_custom_price_with_vat: +(numericValue * 1.2).toFixed(2),
            });
        } else {
            this.setState({
                provider_custom_price_with_vat: numericValue,
                provider_custom_price: +(numericValue / 1.2).toFixed(2),
            });
        }
    };

    onDrop = (acceptedFiles, name) => {
        let oldFiles = [...this.state[name]];
        let files = oldFiles.concat(acceptedFiles);

        this.setState({
            [name]: files,
        });
    };

    removeFile = (file, index, name) => {
        let acceptedFiles = [...this.state[name]];
        acceptedFiles.splice(index, 1);
        this.setState({
            [name]: acceptedFiles,
        });
    };

    onDropReject = (rejectedFiles, name) => {
        this.setState({
            rejectedFiles: { [name]: 'Photo size should be less than 2mb' },
        });
    };

    handleSearchableSelectChange = (e, name) => {
        this.setState({
            [name]: e,
        });
    };

    removeExistingMedia = (imageId) => {
        window.swal
            .fire({
                title: `Delete photo?`,
                text: `Are you sure you want to delete photo??`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: `Delete`,
            })
            .then((isConfirm) => {
                if (isConfirm.dismiss) return;

                $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    },
                    url: `/jobs/${this.props.job.id}/dtn/media/${imageId}`,
                    dataType: 'json',
                    type: 'delete',
                    success: () => {
                        location.reload();
                    },
                });
            });
    };

    onSubmit = (e) => {
        e.preventDefault();

        this.setState({ errors: {} });

        if (this.props.dtn.id) {
            this.onSubmitValidateUpdate(e);
        } else {
            this.onSubmitValidateStore(e);
        }
    };

    saveDtn = async (shouldReload = true) => {
        try {
            if (this.props.dtn.id) {
                await this.onSubmitValidateUpdate(shouldReload);
            } else {
                await this.onSubmitValidateStore(shouldReload);
            }
            return true;
        } catch (err) {
            return false;
        }
    };

    onSubmitValidateStore = async (shouldReload = true) => {
        if (!this.validateForm()) return false;

        this.setState({ loading: true });

        const formData = this.mapInputsToFormData();

        try {
            const res = await this.dtnService.storeDtn(this.props.job.id, formData);
            this.setState({ loading: false });
            toastr.success('Wtn was successfully saved');
            if (shouldReload) location = this.props.editRoute;
            return true;
        } catch (err) {
            this.setState({ loading: false });
            toastr.error('There was a problem while submitting the form. Please try again.');
            throw err;
        }
    };

    onSubmitValidateUpdate = async (shouldReload = true) => {
        if (!this.validateForm()) return false;

        this.setState({ loading: true });

        const formData = this.mapInputsToFormData();

        const oldProviderQuantity = parseInt(this.props.job.provider_quantity, 10) || 0;
        const newProviderQuantity = parseInt(formData.get('provider_quantity'), 10) || oldProviderQuantity;
        const providerJobTypePrice = parseFloat(this.state.providerJobTypePrice) || 0;
        const newProviderTotalPrice = providerJobTypePrice * newProviderQuantity;

        formData.append('new_provider_total_price', newProviderTotalPrice);
        formData.append('_method', 'PATCH');

        try {
            const res = await this.dtnService.updateDtn(this.props.job.id, formData);
            this.setState({ loading: false });
            toastr.success('Wtn was successfully edited');
            if (shouldReload) window.location.reload();
            return true;
        } catch (err) {
            this.setState({ loading: false });
            toastr.error('There was a problem while submitting the form. Please try again.');
            throw err;
        }
    };

    validateForm = () => {
        let errors = {};
        const fields = [
            'address',
            'postcode',
            'collection_date',
            'time_before_loading',
            'time_after_loading',
            'waste_contained',
            'waste_description',
            'completion_time',
            'quantity',
            'provider_quantity',
        ];

        if (this.state.price_quoted === 'yes') {
            fields.push('custom_price');
        }

        if (this.state.provider_price_quoted === 'yes') {
            fields.push('provider_price_quoted');
        }

        // if (!this.props.dtn.id) {
        //     fields.push('route_started');
        //     fields.push('route_arrived');
        //     fields.push('first_operative');
        //     fields.push('job_completed');
        // }

        fields.map((field) => {
            if (!this.state[field] || this.state[field] === undefined) {
                errors[field] = `${snakeCaseToTitle(field)} field is required`;
            }
        });

        this.setState({ errors: errors });
        return Object.keys(errors).length === 0;
    };

    mapInputsToFormData = () => {
        let formData = new FormData();
        const mappable = [
            'address',
            'postcode',
            'collection_date',
            'time_before_loading',
            'time_after_loading',
            'waste_contained',
            'waste_description',
            'job_notes',
            'completion_time',
            'provider_quantity',
            'quantity',
            'sla',
            'purchase_order_number',
            'custom_price',
            'price_quoted',
            'provider_custom_price',
            'provider_price_quoted',
        ];

        // if (!this.props.dtn.id) {
        //     mappable.push('route_started');
        //     mappable.push('route_arrived');
        //     mappable.push('job_completed');
        // }

        formData.append('tyre_extras', JSON.stringify(this.state.selected_extras));
        this.state.images_before
            ? this.state.images_before.forEach((image) => formData.append('images_before[]', image))
            : '';
        this.state.images_after
            ? this.state.images_after.forEach((image) => formData.append('images_after[]', image))
            : '';
        this.state.van_images_before
            ? this.state.van_images_before.forEach((image) => formData.append('van_images_before[]', image))
            : '';
        this.state.van_images_after
            ? this.state.van_images_after.forEach((image) => formData.append('van_images_after[]', image))
            : '';
        this.state.customer_signature ? formData.append('customer_signature', this.state.customer_signature[0]) : '';
        formData.append('tip_off_id', this.state.tipOff.value || '');
        if (!this.props.dtn.id) {
            formData.append('first_operative', this.state.first_operative.value || '');
            formData.append('second_operative', this.state.second_operative.value || '');
        }
        formData.append('manager_review', this.state.manager_review === 'yes' ? 1 : 0);
        formData.append('manager_review_reason', this.state.manager_review_reason);

        mappable.forEach((input) => {
            if (
                input === 'collection_date' ||
                input === 'completion_time' ||
                input === 'route_started' ||
                input === 'route_arrived' ||
                input === 'job_completed'
            ) {
                formData.append(input, this.state[input] ? moment(this.state[input]).format('YYYY/MM/DD HH:mm') : '');
                return;
            }
            if (input === 'time_before_loading' || input === 'time_after_loading') {
                formData.append(input, this.state[input] ? moment(this.state[input]).format('HH:mm') : '');
                return;
            }
            formData.append(input, this.state[input]);
        });

        return formData;
    };

    disableStatusButtons = () => {
        this.setState({
            disable_status_buttons: true,
        });
    };

    render() {
        return (
            <Fragment>
                <form onSubmit={this.onSubmit} className="transform-text">
                    <CustomerDetails
                        customer={this.props.job.customer.name}
                        customer_contact={this.props.job.contact.first_name + ' ' + this.props.job.contact.last_name}
                        job_source={this.props.job_source ? this.props.job_source.job_source : ''}
                        purchase_order_number={this.state.purchase_order_number}
                        sla={this.state.sla}
                        department={this.props.job.contact ? this.props.job.contact.department.name : ''}
                        handleChange={this.handleChange}
                    />

                    <div className="row pb-3">
                        <div className="col-12">
                            <h6 className="py-2 pl-2 cw-bg-grey text-white">Job Details</h6>
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-4">
                            <FormInputText
                                type="text"
                                name="address"
                                label="Address line 1"
                                value={this.state.address}
                                classes={this.state.errors.address ? 'form-control is-invalid' : 'form-control'}
                                error={this.state.errors.address}
                                handleChange={this.handleChange}
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <FormInputText
                                type="text"
                                name="postcode"
                                label="Postcode"
                                value={this.state.postcode}
                                classes={this.state.errors.postcode ? 'form-control is-invalid' : 'form-control'}
                                error={this.state.errors.postcode}
                                handleChange={this.handleChange}
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <SearchableSelect
                                name="tip_offs"
                                options={this.props.tipOffOptions}
                                value={this.state.tipOff}
                                handleChange={(e) => this.handleSearchableSelectChange(e, 'tipOff')}
                                label="Select tip off"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-4">
                            <label>Collection date</label>
                            <DatePicker
                                className={
                                    this.state.errors.collection_date ? 'form-control is-invalid' : 'form-control'
                                }
                                placeholderText="collection date"
                                selected={this.state.collection_date || null}
                                onChange={(date) => this.handleDateChange(date, 'collection_date')}
                                dateFormat="dd/MM/yyyy"
                            />
                            <FormError error={this.state.errors.collection_date} />
                        </div>
                        <div className="form-group col-md-4">
                            <label>Time before loading the waste</label>
                            <DatePicker
                                className={
                                    this.state.errors.time_before_loading ? 'form-control is-invalid' : 'form-control'
                                }
                                placeholderText="time before loading the waste"
                                selected={this.state.time_before_loading || null}
                                onChange={(date) => this.handleDateChange(date, 'time_before_loading')}
                                dateFormat="HH:mm"
                                timeIntervals={15}
                                showTimeSelect
                                showTimeSelectOnly
                            />
                            <FormError error={this.state.errors.time_before_loading} />
                        </div>
                        <div className="form-group col-md-4">
                            <label>Time after loading the waste</label>
                            <DatePicker
                                className={
                                    this.state.errors.time_after_loading ? 'form-control is-invalid' : 'form-control'
                                }
                                placeholderText="time after loading the waste"
                                selected={this.state.time_after_loading || null}
                                onChange={(date) => this.handleDateChange(date, 'time_after_loading')}
                                dateFormat="HH:mm"
                                timeIntervals={15}
                                showTimeSelect
                                showTimeSelectOnly
                            />
                            <FormError error={this.state.errors.time_after_loading} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-4">
                            <label>Completion time</label>
                            <DatePicker
                                className={
                                    this.state.errors.completion_time ? 'form-control is-invalid' : 'form-control'
                                }
                                placeholderText="completion time"
                                selected={this.state.completion_time || null}
                                onChange={(date) => this.handleDateChange(date, 'completion_time')}
                                dateFormat="dd/MM/yyyy HH:mm"
                                timeFormat="HH:mm"
                                timeIntervals={15}
                                showTimeSelect
                            />
                            <FormError error={this.state.errors.completion_time} />
                        </div>
                        <div className="form-group col-md-4">
                            <FormInputNumber
                                type="number"
                                label="Provider quantity"
                                name="provider_quantity"
                                step="1"
                                min="0"
                                classes="form-control"
                                value={this.state.provider_quantity}
                                handleChange={this.handleChange}
                            />
                            <FormError error={this.state.errors.provider_quantity} />
                        </div>
                        <div className="form-group col-md-4">
                            <FormInputNumber
                                type="number"
                                label="Quantity"
                                name="quantity"
                                step="1"
                                min="0"
                                classes="form-control"
                                value={this.state.quantity}
                                handleChange={this.handleChange}
                            />
                            <FormError error={this.state.errors.quantity} />
                        </div>
                    </div>

                    {this.props.previousFollowOnDescription ? (
                        <div className="row">
                            <div className="form-group col-md-12">
                                <label>Previous job notes</label>
                                <textarea
                                    name="previous_job_notes"
                                    id="previous_job_notes"
                                    className="form-control"
                                    value={this.props.previousFollowOnDescription}
                                    rows={5}
                                    disabled
                                >
                                    {this.props.previousFollowOnDescription}
                                </textarea>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}

                    <div className="row">
                        <div className="form-group col-md-12">
                            <label>Admin notes</label>
                            <textarea
                                name="admin_notes"
                                id="admin_notes"
                                rows={5}
                                value={this.state.admin_notes}
                                onChange={this.handleChange}
                                placeholder="Admin note"
                                className="form-control"
                            >
                                {this.state.admin_notes}
                            </textarea>
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-12">
                            <label>Job notes</label>
                            <textarea
                                className="form-control"
                                name="job_notes"
                                id="job_notes"
                                value={this.state.job_notes}
                                onChange={this.handleChange}
                                placeholder="Job notes..."
                                rows="5"
                            ></textarea>
                        </div>
                    </div>

                    {this.state.manager_review === 'yes' ? (
                        <div className="row">
                            <div className="col-12">
                                <FormInputText
                                    label="Manager Review Reason"
                                    name="manager_review_reason"
                                    type="text"
                                    classes={
                                        this.state.errors.manager_review_reason
                                            ? 'form-control is-invalid'
                                            : 'form-control'
                                    }
                                    value={this.state.manager_review_reason}
                                    handleChange={this.handleChange}
                                    error={this.state.errors.manager_review_reason}
                                />
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                    {this.props.job.manager_review_flag_reason ? (
                        <div className="row">
                            <div className="col-12">
                                <p>Manager Review Flagged by: {this.props.job.manager_review_flag_reason}</p>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                    <div className="row">
                        <div className="col-12">
                            <FormCheckbox
                                name="manager_review"
                                label="MANAGER REVIEW"
                                checked={this.state.manager_review === 'yes'}
                                handleChange={this.handleChange}
                            />
                        </div>
                    </div>

                    {!this.props.dtn.id ? (
                        <OperativeDetails
                            first_operative={this.state.first_operative}
                            second_operative={this.state.second_operative}
                            second_member_id={this.state.second_member_id}
                            route_started={this.state.route_started}
                            route_arrived={this.state.route_arrived}
                            job_completed={this.state.job_completed}
                            errors={this.state.errors}
                            operatives={this.props.operatives}
                            handleDateChange={this.handleDateChange}
                            handleChange={this.handleChange}
                            handleSearchableSelectChange={this.handleSearchableSelectChange}
                        />
                    ) : (
                        ''
                    )}

                    <div className="row pb-3">
                        <div className="col-12">
                            <h6 className="py-2 pl-2 cw-bg-grey text-white">Waste collected</h6>
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-6">
                            <FormInputText
                                type="text"
                                name="waste_contained"
                                label="How was the waste contained:"
                                value={this.state.waste_contained}
                                classes={this.state.errors.waste_contained ? 'form-control is-invalid' : 'form-control'}
                                error={this.state.errors.waste_contained}
                                handleChange={this.handleChange}
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <FormInputText
                                type="text"
                                name="waste_description"
                                label="Description of the waste being collected:"
                                value={this.state.waste_description}
                                classes={
                                    this.state.errors.waste_description ? 'form-control is-invalid' : 'form-control'
                                }
                                error={this.state.errors.waste_description}
                                handleChange={this.handleChange}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-6">
                            <FormMultiSelect
                                label="Job Extras"
                                options={this.state.extras_options}
                                handleMultiSelectChange={(value) =>
                                    this.handleMultiSelectChange(value, 'selected_extras')
                                }
                                classes={'form-control'}
                                prefixes={this.state.selected_extras}
                            />
                        </div>
                    </div>

                    <JobExtras
                        extras={this.state.selected_extras}
                        onExtraQtyChange={this.handleExtraQtyChange}
                        extrasType={'selected_extras'}
                        providerExtrasType={'tyre_types'}
                        extrasPrices={this.props.tyreTypes}
                        serviceProvider={this.props.serviceProvider}
                        dtn={true}
                    />

                    <PricingDetails
                        totalPrice={this.state.totalPrice}
                        timeSpentWorking={this.props.timeSpentWorking}
                        laborCost={this.props.laborCost}
                        providerTotalPrice={this.state.providerTotalPrice}
                        price_quoted={this.state.price_quoted}
                        custom_price={this.state.custom_price}
                        custom_price_with_vat={this.state.custom_price_with_vat}
                        provider_price_quoted={this.state.provider_price_quoted}
                        provider_custom_price={this.state.provider_custom_price}
                        provider_custom_price_with_vat={this.state.provider_custom_price_with_vat}
                        handleProviderCustomPriceChange={this.handleProviderCustomPriceChange}
                        handleChange={this.handleChange}
                        additionalCosts={this.state.additionalCosts}
                        handleCustomPriceChange={this.handleCustomPriceChange}
                        jobType={this.props.job.job_type}
                    />

                    <DtnPhotos
                        title="Photos before clearing"
                        name="images_before"
                        acceptedFiles={this.state.images_before}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.images_before}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DtnPhotos
                        title="Photos after clearing"
                        name="images_after"
                        acceptedFiles={this.state.images_after}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.images_after}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DtnPhotos
                        title="Van photos before clearing"
                        name="van_images_before"
                        acceptedFiles={this.state.van_images_before}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.van_images_before}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DtnPhotos
                        title="Van photos after clearing"
                        name="van_images_after"
                        acceptedFiles={this.state.van_images_after}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.van_images_after}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DriverSignature imagePath={this.props.signaturePath} driver={this.props.driver} />

                    <DtnPhotos
                        title="Customer signature"
                        name="customer_signature"
                        acceptedFiles={this.state.customer_signature}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.customer_signature}
                        multiple={false}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <SubmitButton
                        buttonText={this.props.dtn.id ? 'Edit WTN' : 'Create WTN'}
                        loading={this.state.loading}
                        style={{ width: 200, marginTop: 20 }}
                    />
                    <StatusButtons
                        job={this.props.job}
                        jobId={this.props.job.id}
                        style={{ marginTop: 20 }}
                        disabled={this.state.disable_status_buttons}
                        disableStatusButtons={this.disableStatusButtons}
                        saveDtn={this.saveDtn}
                        user={this.props.currentUser}
                    />
                    <a
                        href={this.props.downloadUrl}
                        className="btn btn-cw-green"
                        style={{ width: 200, marginTop: 20, marginLeft: 15 }}
                    >
                        Download WTN
                    </a>
                </form>
            </Fragment>
        );
    }
}

if (document.getElementById('edit-tyres')) {
    let element = document.getElementById('edit-tyres');

    ReactDOM.render(
        <EditTyreCollection
            job={JSON.parse(element.dataset.job)}
            dtn={JSON.parse(element.dataset.dtn)}
            type={JSON.parse(element.dataset.type)}
            tyreTypes={JSON.parse(element.dataset.tyre_types)}
            media={JSON.parse(element.dataset.media)}
            signaturePath={element.dataset.signature_path}
            jobTypes={JSON.parse(element.dataset.job_types)}
            timeSpentWorking={element.dataset.time_spent_working}
            laborCost={element.dataset.labor_cost}
            tipOffOptions={JSON.parse(element.dataset.tip_off_options)}
            downloadUrl={element.dataset.download_url}
            serviceProvider={JSON.parse(element.dataset.service_provider)}
            driver={element.dataset.driver !== null ? JSON.parse(element.dataset.driver) : null}
            completeAndFollowOnRoute={element.dataset.status_and_follow_on_route}
            operatives={element.dataset.operatives ? JSON.parse(element.dataset.operatives) : []}
            editRoute={element.dataset.edit_route}
            currentUser={JSON.parse(element.dataset.currentUser)}
        />,
        element
    );
}
export default EditTyreCollection;
